import React from 'react';
import { motion } from 'framer-motion';

// NOTE: this component used to also rewrite <link rel="canonical"> on mount,
// building the URL from window.location.pathname with the trailing slash
// stripped. That fought with the canonical SEO.jsx renders via react-helmet:
// it overwrote helmet's tag during react-snap's prerender (baking the slashless
// URL into every static page) and left a duplicate canonical at runtime. The
// slashless URL is the one this host serves the homepage at, so every course
// and blog page ended up canonicalised to the homepage. SEO.jsx is the single
// owner of the canonical now — do not reintroduce a second writer here.
const PageTransition = ({ children }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
    >
      {children}
    </motion.div>
  );
};

export default PageTransition;
